import { useEffect, useState } from "react";
import { Send, BellRing } from "lucide-react";
import { api } from "../../lib/api";
import { DeliverEbookDialog } from "./DeliverEbookDialog";

const opts = { withCredentials: true };
const PENDING = ["demande", "confirmee", "payee"];

export const PendingDeliveries = ({ onDone }) => {
  const [orders, setOrders] = useState([]);
  const [extracts, setExtracts] = useState([]);
  const [current, setCurrent] = useState(null);
  const load = () => api.get("/admin/orders", opts).then((r) => setOrders(r.data.filter((o) => o.version === "numerique" && PENDING.includes(o.status)))).catch(() => {});
  useEffect(() => { load(); api.get("/admin/extracts", opts).then((r) => setExtracts(r.data)).catch(() => {}); }, []);
  if (!orders.length) return null;
  return (
    <section data-testid="pending-deliveries" className="border-l-4 border-[#9E4735] bg-[#9E4735]/5 p-4 mb-8 font-body">
      <p className="flex items-center gap-2 text-sm text-[#1A1A1A] mb-3"><BellRing size={16} className="text-[#9E4735]" />
        <strong data-testid="pending-deliveries-count">{orders.length} commande{orders.length > 1 ? "s" : ""} numérique{orders.length > 1 ? "s" : ""} à livrer</strong>
        <span className="text-xs text-[#757575]">— vérifiez le paiement puis cliquez sur « Livrer »</span>
      </p>
      <ul className="space-y-2 max-h-[260px] overflow-y-auto">
        {orders.map((o) => (
          <li key={o.id} data-testid={`pending-${o.ref}`} className="flex flex-wrap items-center gap-x-4 gap-y-1 bg-[#FAF9F6] border border-[#D1CFC7] px-3 py-2 text-xs">
            <span className="font-mono">{o.ref}</span>
            <span className="font-semibold">{o.title}</span>
            <span className="text-[#4A4A4A]">{o.customer_name || "Client à préciser"}{o.customer_phone ? ` · ${o.customer_phone}` : ""}</span>
            <span className="text-[#757575]">{new Date(o.created_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}{o.lieu_name ? ` · ${o.lieu_name}` : ""}</span>
            <button onClick={() => setCurrent(o)} data-testid={`pending-deliver-${o.ref}`} className="ml-auto bg-[#2C402E] text-[#FAF9F6] px-3 py-1.5 flex items-center gap-1.5"><Send size={12} /> Livrer</button>
          </li>
        ))}
      </ul>
      <DeliverEbookDialog order={current} extracts={extracts} open={!!current} onOpenChange={(v) => !v && setCurrent(null)} onDone={() => { load(); onDone?.(); }} />
    </section>
  );
};
